import { environment } from './environments/environment';

export const ASSETS = {
  images: {
    welcomeImage: '/assets/pexels-keira-burton-6146929.jpg',
    quitLineImage: '/assets/pexels-pixabay-263564.jpg',
    leadTestingImage: '/assets/pexels-edward-jenner-4032060.jpg',
    thankYouImage: '/assets/pexels-cottonbro-studio-7579831.jpg',
    http404ErrorImage: '/assets/pexels-ds-stories-6991443.jpg',
    http500ErrorImage: '/assets/pexels-andre-moura-3809702.jpg',
    http503ErrorImage: '/assets/pexels-rfstudio-3825581.jpg',
    anthemLogoBlue: '/assets/abs_r_h_rgb_c2.svg',
    hcc_card: '/assets/HCC_ID_Card.jpg',
    hip_card: '/assets/HIP_ID_Card.jpg',
    hhw_card: '/assets/HHW_ID_Card.jpg',
  },
  icons: {
    writingPad: '/assets/writing-pad-line-icon.svg',
    star: '/assets/star-empty-icon.svg',
    lightBulb: '/assets/bulb-exclamation-mark-icon.svg',
    screen: '/assets/screen-icon.svg',
    smartphone: '/assets/smartphone-icon.svg',
  },
  appInfo: {
    environment: environment.name,
  },
} as const;
